import Duck from "redux-ducks-ts"

export const quoteTemplate = new Duck("quoteTemplate", "cargo")
